import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { dismissBootShell, renderFatalBootError } from '@/lib/boot'
import { installGlobalErrorHandlers, report } from '@/lib/telemetry'
import '@/styles.css'

installGlobalErrorHandlers()

try {
  const rootEl = document.getElementById('root')
  if (!rootEl) throw new Error('Root element #root is missing from the document')

  const root = createRoot(rootEl, {
    onUncaughtError: (error) => {
      report({
        level: 'error',
        event: 'react.uncaught',
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
      })
    },
  })

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )

  // Hand off from the inline shell only once React has actually committed a
  // frame, so there is no flash of empty page between the two.
  requestAnimationFrame(() => {
    requestAnimationFrame(dismissBootShell)
  })

  // Backstop, because requestAnimationFrame does not fire while the tab is
  // hidden. Launching the app and immediately switching away would otherwise
  // leave the boot overlay covering the UI until the user returned *and* a
  // frame was painted. `dismissBootShell` is idempotent, so whichever path
  // runs first wins and the other is a no-op.
  setTimeout(dismissBootShell, 1500)
} catch (err) {
  // React never mounted, so its error boundary cannot help here.
  const message = err instanceof Error ? err.message : String(err)
  report({ level: 'error', event: 'boot.mount_failed', message })
  renderFatalBootError(message)
}
